<template>
  <div>
    <header class="main-content--header">
      <div class="columns">
        <div class="column left">
          <router-link to="/admin/settings" class="router-link-active">
            <h4>Admin Settings</h4>
          </router-link>
        </div>
        <div class="column right">
          <router-link to="/admin" class="router-link-active">
            Go to Admin Reports
          </router-link>
        </div>
      </div>
    </header>
    <section class="main-content--body">
      <div class="wrapper-md">
        <div class="main-content--panel">
          <div class="panel--top">
            <div class="m-t-lg">
              <h3 class="text-left text-md m-t-lg">Message Style</h3>
              <p class="text-left text-sm m-t-sm">Select how you want your Worklogs messages to display on Slack</p>
              <form class="m-t-md" @submit.prevent="submit">
                <div class="control">
                  <label class="radio">
                    <input type="radio" value="2" name="question" v-model="messagetype">
                    <img class="img" src="../assets/img/oneline.png">
                  </label>
                  <label class="radio second-radio">
                    <input type="radio" value="1" name="question" v-model="messagetype">
                    <img class="img" src="../assets/img/multiline.png">
                  </label>
                </div>
                <div class="control submit m-t-md">
                  <button @click="submit()" class="button is-primary save-btn" v-bind:class="{ 'is-disabled' : disabled }">Update
                    <span v-bind:class="{ 'sslack-loader' : sloading }"></span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import axios from 'axios'
  import { store } from '../store/store';
  import moment from 'moment'
  import tz from 'moment-timezone'
  export default {
    name: 'AdminSetting',
    data () {
      return {
        id: null,
        users: null,
        loading: false,
        sloading: false,
        disabled: false,
        messagetype: null
      }
    },
    head: {
      title: {
        inner: 'Admin Settings',
        separator: '-',
        complement: 'Worklogs'
      },
    },
    created () {
      this.fetchData()
    },
    watch: {
      '$route': 'fetchData'
    },
    methods: {
      fetchData () {
        var self = this
        this.loading = true
        axios.get('https://api.kuzcoapp.com/api/v1/team')
          .then(function (response) {
            self.$Progress.finish()
            var _team = response.data.data.name
            var _id = response.data.data.id
            var _slackid = response.data.data.slack_id
            axios.get('https://api.kuzcoapp.com/api/v1/admin/users/' + _slackid)
              .then( function (response) {
                self.loading = false
                var _users = response.data.data
                var _usersobj = {}
                for( var i in _users) {
                  var _date  = moment(_users[i].created_at).format('MMMM Do YYYY, h:mm:ss a')
                  self.id = _users[i].id
                  _usersobj[i] = {
                    name: _users[i].name,
                    email: _users[i].email,
                    date: _date,
                    id: _users[i].id
                  }
                }
                self.users = _usersobj
              })
              .catch(function (error) {
                console.log(error);
              });
          })
          .catch(function (error) {
            console.log(error);
          });
        axios.get('https://api.kuzcoapp.com/api/admin/message_style')
          .then(response => {
            this.messagetype = response.data.data
          })
          .catch(error => {
            console.log(error)
          })
      },
      submit: function () {
        this.sloading = true
        this.disabled = true
        axios.post('https://api.kuzcoapp.com/api/admin/message_style', {
          style: this.messagetype
        })
          .then(response => {
            this.sloading = false
            this.disabled = false
          })
          .catch(error => {
            this.sloading = false
            this.disabled = false
            console.log(error)
          })
      }
    },
    computed: {
      teamid () {
        return store.state.teamid;
        this.slackteamid = this.$store.state.teamid;
      },
      teamslackid () {
        return store.state.teamslackid;
        this.slackid = this.$store.state.teamslackid;
      }
    }
  }
</script>

<style scoped lang="scss" type="text/scss">
  $themecolor: #4671fb;
  $oldthemecolor: #3e454f;
  $kuzcogreen: #40CF97;
  .kuzco-green {
    background-color: $kuzcogreen !important;
  }
  .main-content--header {
    .left {
      a {
        color: $oldthemecolor;
      }
    }
    .right {
      color: $oldthemecolor;
      text-align: right;
      a {
        border-bottom: 0;
        color: $oldthemecolor;
        font-size: 18px;
      }
      i {
        margin-right: 5px;
        margin-top: 6px;
      }
    }
  }
  h3 {
    font-size: 20px;
    margin-bottom: 20px;
    span {
      font-family: "Proxima Bold";
    }
  }
  .main-content--body {
    height: 100vh;
  }
  .second-radio {
    margin-top: 15px;
    margin-left: 0;
  }
  .save-btn {
    background-color: $kuzcogreen;
    color: #fff;
    border-radius: 3px;
    font-size: 14px;
    letter-spacing: 1px;
  }
  .status {
    border-radius: 100%;
    width: 8px;
    height: 8px;
    border-width: 4px;
    color: $kuzcogreen;
    border-style: solid;
    display: inline-block;
  }
  table {
    font-size: 14px;
  }
  th {
    padding: 15px;
    border-bottom: 1px solid #D7E2E9;
  }
  td {
    padding: 15px;
    border-top: 1px solid #D7E2E9;
  }
  .loading-icon {
    padding-top: 50px;
    padding-bottom: 50px;
  }
  .slack-loader {
    margin: 0 auto;
    display: flex;
    /*display: inline-block;*/
    /*margin: 0 15px;*/
    font-size: 12px;
    text-indent: -9999em;
    width: 3em;
    height: 3em;
    border-radius: 50%;
    background: #ffffff;
    background: -moz-linear-gradient(left, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
    background: -webkit-linear-gradient(left, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
    background: -o-linear-gradient(left, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
    background: -ms-linear-gradient(left, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
    background: linear-gradient(to right, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
    position: relative;
    -webkit-animation: load3 1.4s infinite linear;
    animation: load3 1.4s infinite linear;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
  }
  .slack-loader:before {
    width: 50%;
    height: 50%;
    background: $kuzcogreen;
    border-radius: 100% 0 0 0;
    position: absolute;
    top: 0;
    left: 0;
    content: '';
  }
  .slack-loader:after {
    background: #ffffff;
    width: 75%;
    height: 75%;
    border-radius: 50%;
    content: '';
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
  @-webkit-keyframes load3 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load3 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  .sslack-loader {
    margin: -4px auto;
    display: inline-block;
    font-size: 4px;
    text-indent: -9999em;
    width: 4em;
    height: 4em;
    border-radius: 50%;
    background: #ffffff;
    background: -moz-linear-gradient(left, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
    background: -webkit-linear-gradient(left, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
    background: -o-linear-gradient(left, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
    background: -ms-linear-gradient(left, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
    background: linear-gradient(to right, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
    position: relative;
    -webkit-animation: load3 1.4s infinite linear;
    animation: load3 1.4s infinite linear;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
  }
  .sslack-loader:before {
    width: 50%;
    height: 50%;
    background: #ffffff;
    border-radius: 100% 0 0 0;
    position: absolute;
    top: 0;
    left: 0;
    content: '';
  }
  .sslack-loader:after {
    background: $kuzcogreen;
    width: 75%;
    height: 75%;
    border-radius: 50%;
    content: '';
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
  @-webkit-keyframes load3 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load3 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// AdminSetting.vue?542c1e4a